module.exports = __webpack_public_path__ + "8b828ad66a336e14fb33705cdfd9cb83.MP3";